<template>
  <div class="form-single-fragment" style="position: relative;">
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
    <el-form ref="temporaryWorkFeedbackForm" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20" v-if="formData.TemporaryWorkFeedback.createUserIdDictMap">
        <el-col :span="12">
          <el-form-item label="派送人">
            <el-input v-model="formData.TemporaryWorkFeedback.createUserIdDictMap.name"  readOnly
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="接收人">
          <el-input v-model="formData.TemporaryWorkFeedback.receiveUserIdDictMap.name"  readOnly
                    autocomplete="off"></el-input>
        </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="是否完成">
            <el-input v-model="formData.TemporaryWorkFeedback.dealStatusDictMap.name"  readOnly
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formData.TemporaryWorkFeedback.isLateDictMap">
          <el-form-item label="是否超时">
            <el-input v-model="formData.TemporaryWorkFeedback.isLateDictMap.name"  readOnly
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="反馈内容">
            <el-input v-model="formData.TemporaryWorkFeedback.dealDesc" type="textarea" :rows="2"  readOnly autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件" prop="TemporaryWorkFeedback.attachedFiles">
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple
              :action="getUploadActionUrl('/admin/app/temporaryWorkFeedback/upload')"
              :data="{fieldName: 'attachedFiles', asImage: false}"
              :on-success="onAttachedFilesUploadSuccess"
              :on-remove="onAttachedFilesRemoveFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              :limit="temporaryWorkFeedbackForm.attachedFiles.impl.maxCount"
              :file-list="temporaryWorkFeedbackForm.attachedFiles.impl.fileList"
              :show-file-list="false">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="temporaryWorkFeedbackForm.attachedFiles.impl.fileList &&
            temporaryWorkFeedbackForm.attachedFiles.impl.fileList[0] !=
            null" style="position: relative">
              <div v-for="(item,index) in temporaryWorkFeedbackForm.attachedFiles.impl.fileList" :key="item.url"
                   style="display:flex;margin-top: 5px;">
                <div> {{item.name}}</div>
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                  <el-button type="primary" v-if="checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')"
                             @click="deleteAttachedFiles(item,temporaryWorkFeedbackForm.attachedFiles.impl.fileList,index)">删除
                  </el-button>
                </div>

              </div>
            </div>
            <template v-else>
              <a v-for="item in temporaryWorkFeedbackForm.attachedFiles.impl.fileList" :key="item.url"
                 href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
                {{item.name}}
              </a>
            </template>
          </el-form-item>
        </el-col>

          <el-col :span="12">
            <el-form-item label="考核分数">
              <el-input v-model="formData.TemporaryWorkFeedback.assessmentScore" type="number" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row class="no-scroll flex-box" type="flex" justify="left">
              <el-button type="primary" :size="defaultFormItemSize"  @click="onScoreClick()"
                         v-if="checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')">
                保存
              </el-button>
            </el-row>
          </el-col>

      </el-row>

    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { TemporaryWorkFeedbackController, DictionaryController } from '@/api';

export default {
  name: 'temporaryWorkFeedbackForm',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      formData: {
        TemporaryWorkFeedback: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          receiveUserId: undefined,
          createUserName: undefined,
          receiveUserName: undefined,
          workType: undefined,
          workId: undefined,
          dealStatus: undefined,
          picture: undefined,
          dealTime: undefined,
          isLate: undefined,
          assessmentScore: undefined,
          dealDesc: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        }
      },
      temporaryWorkFeedbackForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        picture: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(1)
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 更新临时工作反馈表单
     */
    refreshTemporaryWorkFeedbackForm (reloadData = false) {
      this.loadTemporaryWorkFeedbackData().then(res => {
        if (!this.temporaryWorkFeedbackForm.isInit) {
          // 初始化下拉数据
        }
        this.temporaryWorkFeedbackForm.isInit = true;
      })
    },
    onResume () {
      this.refreshTemporaryWorkFeedbackForm(true);
    },
    initFormData () {
    },
    loadTemporaryWorkFeedbackData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.TemporaryWorkFeedback.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          TemporaryWorkFeedbackController.view(this, params).then(res => {
            this.formData.TemporaryWorkFeedback = {...res.data, isDatasourceInit: true};
            let attachedFilesDownloadParams = {
              id: this.formData.TemporaryWorkFeedback.id,
              fieldName: 'attachedFiles',
              asImage: false
            }
            this.temporaryWorkFeedbackForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.TemporaryWorkFeedback.attachedFiles,
              attachedFilesDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.TemporaryWorkFeedback.isDatasourceInit = true;
          resolve();
        }
      });
    },
    onScoreClick () {
      if (!this.formData.TemporaryWorkFeedback.assessmentScore) {
        this.$message.error('请填写分数');
        return;
      }
      let params = {
        temporaryWorkFeedbackDto: {
          ...this.formData.TemporaryWorkFeedback
        }
      }

      TemporaryWorkFeedbackController.update(this, params).then(res => {
        this.$message.success('保存成功');
        this.onCancel(true);
      }).catch(e => {});
    },
    /**
     * 图片上传成功
     */
    onPictureUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.temporaryWorkFeedbackForm.picture.impl.onFileChange(file, fileList);
        this.formData.TemporaryWorkFeedback.picture = this.fileListToJson(this.temporaryWorkFeedbackForm.picture.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除图片
     */
    onPictureRemoveFile (file, fileList) {
      this.temporaryWorkFeedbackForm.picture.impl.onFileChange(file, fileList);
      this.formData.TemporaryWorkFeedback.picture = this.fileListToJson(this.temporaryWorkFeedbackForm.picture.impl.fileList);
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.temporaryWorkFeedbackForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.TemporaryWorkFeedback.attachedFiles = this.fileListToJson(this.temporaryWorkFeedbackForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    /**
     * 移除附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.temporaryWorkFeedbackForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.TemporaryWorkFeedback.attachedFiles = this.fileListToJson(this.temporaryWorkFeedbackForm.attachedFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        TemporaryWorkFeedback: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          receiveUserId: undefined,
          createUserName: undefined,
          receiveUserName: undefined,
          workType: undefined,
          workId: undefined,
          dealStatus: undefined,
          picture: undefined,
          dealTime: undefined,
          isLate: undefined,
          assessmentScore: undefined,
          dealDesc: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshTemporaryWorkFeedbackForm();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
